import styled, { css } from 'styled-components';
import { hexToRgba } from '../../../../features/helpers/hexToRgba';
import { fadeIn } from '../../../../theme/keyframes';
import Collapse from '../../../common/Collapse';
import Grid from '../../../common/hd-grid';
import Select from '../../../common/select';
export const FilterSelect = styled(Select) `
  position: relative;

  &.ant-select-multiple.ant-select-lg {
    padding-block: 0;
  }
`;
export const FilterSelectDropdown = styled.div `
  padding: 0;

  .ant-select-item {
    padding: 0;
  }
`;
export const FiltersGrid = styled(Grid) `
  ${({ $needSaving }) => $needSaving
    ? `
& > .ant-col:last-child {
  max-width: calc((100% / 3) * 2);
  flex: 0 0 calc((100% / 3) * 2);
  padding: 12px 6px 0 54px !important;
  &..ant-col-24 {
    max-width: 100%;
    flex: 0 0 100%;
  }
}
`
    : undefined}
`;
export const FundingExplorerTagBarContainer = styled.div `
  width: ${({ $contained }) => ($contained ? '100%' : 'calc(100% + 48px)')};
  margin-inline: ${({ $contained }) => ($contained ? 0 : '-24px')};
  padding-inline: 0;
  padding-block: ${({ theme }) => theme.spacing.sm}px;
  margin-top: 0;
  ${({ $isOpen, $withDrawer, theme }) => !$isOpen && $withDrawer
    ? `

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: calc(16px + 12px);
    width: 100%;
    z-index: 1;
    pointer-events: none;
    
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      ${hexToRgba(theme.colors.white_1)}
      );
      }
      `
    : undefined}
  max-height: ${({ $isOpen, $withDrawer }) => $isOpen || !$withDrawer ? 'auto' : '70px'};
`;
export const FundingExplorerTagBarStyled = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm}px;
  height: 100%;
  width: 100%;

  position: relative;
`;
export const FilterMultipleSelectStyled = styled(Select) `
  ${({ $isMultiple }) => $isMultiple
    ? css `
          .ant-select-selection-overflow,
          .ant-select-selection-overflow-item span {
            overflow: hidden;
          }
        `
    : undefined}
`;
export const FilterSectionContainterStyled = styled.div `
  z-index: 500;

  animation: ${fadeIn} 200ms linear;

  ${({ $position, theme }) => $position === 'top'
    ? css `
          position: absolute;
          top: 0;
          right: 0;
          width: 100%;
          @media only screen and (max-width: ${theme.breakpoints.tablet}px) {
            position: relative;
          }
        `
    : css `
          position: absolute;
          bottom: 0;
          right: 0;
          width: 100%;
          transition: width 180ms linear;
          @media only screen and (max-width: ${theme.breakpoints.tablet}px) {
            position: relative;
            width: 100%;
          }
        `}
`;
export const FilterSectionStyled = styled.div `
  overflow: hidden;

  background-color: ${({ theme }) => theme.colors.white_1};
  padding: ${({ $compact }) => ($compact ? `0 24px` : '12px 24px')};
  border-radius: 0;
  box-shadow: none;
  backdrop-filter: blur(20px);

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    backdrop-filter: none;
    padding: ${({ $compact }) => ($compact ? `0 24px` : '12px 24px')};
    box-shadow: none;
  }
`;
export const FilterDropdownDesktopDrawerStyled = styled.div `
  display: ${({ $open }) => ($open ? 'block' : 'none')};
  position: absolute;
  top: 100%;
  backdrop-filter: blur(20px);
  width: 100%;
  left: 0;
  padding: 0;
  z-index: 200;
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  background-color: ${({ theme }) => theme.colors.white_2};
  border-radius: 4px;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
`;
export const CompanyCollapse = styled(Collapse) ``;
